import React, { useState, useEffect } from 'react';
import { Divider, Typography } from "antd";
import { Circle, Square, Triangle } from 'lucide-react';
import './ShapeLoader.css'; // We'll add CSS later

function ShapeLoader({ message }) {
  const [animationState, setAnimationState] = useState('initial');

  useEffect(() => {
    // Function to trigger random animations with delays
    const triggerRandomAnimation = () => {
      const animations = ['spin', 'bounce', 'pulse'];
      const randomIndex = Math.floor(Math.random() * animations.length);
      const randomDelay = Math.random() * 2000 + 1000; // Delay between 1s and 3s

      setAnimationState(animations[randomIndex]);

      setTimeout(() => {
        setAnimationState('initial'); // Reset to initial state
        triggerRandomAnimation(); // Trigger another animation after a delay
      }, randomDelay);
    };

    triggerRandomAnimation(); // Start the animation loop

    return () => clearTimeout(triggerRandomAnimation); // Cleanup on unmount
  }, []);

  return (
    <div className="shape-loader p-6">
      <div className={`triangle ${animationState}`} style={{color: '#da1761'}}><Triangle size={48} /></div>
      <div className="shapes-container">
        <div className={`circle ${animationState}`} style={{color: '#0068ff'}}><Circle size={48} /></div>
        <div className={`square ${animationState}`} style={{color: '#710ac2'}}><Square size={48} /></div>
      </div>
      {message && (
          <>
          <Divider/>
            <Typography.Text>{message}</Typography.Text>
          </>
      )}
    </div>
  );
}

export default ShapeLoader;